import { TimeAgoElement } from "@github/time-elements"

// Behaves like time-ogo, except uses the current time minus an offset.
// Offset should be in the "offset" attribute in seconds
class ExampleTimeAgoElement extends TimeAgoElement {
  connectedCallback() {
    const offset = parseInt(this.getAttribute("offset") || 0)
    this.setAttribute("datetime", new Date(Date.now() - offset * 1000))
    super.connectedCallback()
  }
}
customElements.define("example-time-ago", ExampleTimeAgoElement)
